// extracted by mini-css-extract-plugin
export default {"map_canvas":"PriceMapRegionList_map_canvas__-ZCGG"};